// src/pages/administradores/AdministradorForm.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { apiRequest } from '../../services/apiService';
import { Administrador } from '../../data/Administrador';

function AdministradorForm() {
  const { id } = useParams<{ id: string }>();
  const [administrador, setAdministrador] = useState<Partial<Administrador>>({
    nome: '',
    cpf: '',
    email: '',
    telefone: '',
    ativo: true,
    admin: true
  });
  const [loading, setLoading] = useState(!!id);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      apiRequest<Administrador>(`usuarios/administrador/${id}`, 'GET', true)
        .then(data => {
          setAdministrador({
            ...data
          });
        })
        .catch(err => setError((err as Error).message || 'Erro ao carregar administrador.'))
        .finally(() => setLoading(false));
    }
  }, [id]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setAdministrador(prevAdministrador => ({
      ...prevAdministrador,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await apiRequest('registro/registroprivado', 'POST', true, administrador);
      
      navigate('/administradores');
    } catch (err) {
      setError((err as Error).message || 'Erro ao salvar administrador.');
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return <p>Carregando...</p>;
  }

  return (
    <div className="row">
      <div className="card">
        <div className="card-body">
          <div className="mb-3">
            <h1 className="h3 d-inline align-middle">{id ? 'Editar Administrador' : 'Novo Administrador'}</h1>
          </div>
          {error && <div className="alert alert-danger">Erro: {error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-8 mb-3">
                <label htmlFor="nome" className="form-label">Nome Completo</label>
                <input type="text" id="nome" name="nome" className="form-control" value={administrador.nome || ''} onChange={handleChange} required />
              </div>
              
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="cpf" className="form-label">CPF</label>
                <input type="text" id="cpf" name="cpf" className="form-control" value={administrador.cpf || ''} onChange={handleChange} required />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input type="email" id="email" name="email" className="form-control" value={administrador.email || ''} onChange={handleChange} required />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="telefone" className="form-label">Telefone</label>
                <input type="tel" id="telefone" name="telefone" className="form-control" value={administrador.telefone || ''} onChange={handleChange} />
              </div>
            </div>

            <div className="mb-3 form-check">
              <input type="checkbox" id="ativo" name="ativo" className="form-check-input" checked={!!administrador.ativo} onChange={handleChange} />
              <label htmlFor="ativo" className="form-check-label">Ativo</label>
            </div>

            <hr />

            <button type="submit" disabled={loading} className="btn btn-primary me-2">
              {loading ? 'Salvando...' : (id ? 'Atualizar' : 'Salvar')}
            </button>
            <Link to="/administradores" className="btn btn-secondary">Cancelar</Link>
          </form>
        </div>
      </div>
    </div>
 );
}

export default AdministradorForm;